import sportsbetLogo from '../../assets/sb.png';
import tabLogo from '../../assets/tab.jpg';
import pointsbetLogo from '../../assets/pb.png';
import nedsLogo from '../../assets/neds.jpg';
import betrightLogo from '../../assets/betright.jpg';
import bet365Logo from '../../assets/bet365.png';
import betmakersLogo from '../../assets/betmakers.png';
import ladbrokesLogo from '../../assets/ladbrokes.webp';
import dabbleLogo from '../../assets/dabble.webp';
import tabtouchLogo from '../../assets/tabtouch.webp';
import unibetLogo from '../../assets/unibet.webp';
import amusedLogo from '../../assets/amused.jpg';

export const BOOKMAKER_LOGOS = {
    sportsbet: sportsbetLogo,
    tab: tabLogo,
    pointsbet: pointsbetLogo,
    neds: nedsLogo,
    betright: betrightLogo,
    bet365: bet365Logo,
    betmakers: betmakersLogo,
    ladbrokes: ladbrokesLogo,
    dabble: dabbleLogo,
    tabtouch: tabtouchLogo,
    unibet: unibetLogo,
    amused: amusedLogo,
};

export const BOOKMAKER_DISPLAY_NAMES = {
    sportsbet: 'Sportsbet',
    tab: 'TAB',
    pointsbet: 'Pointsbet',
    neds: 'Neds',
    betright: 'Betright',
    bet365: 'Bet365',
    betmakers: 'Betmakers',
    ladbrokes: 'Ladbrokes',
    unibet: 'Unibet',
    betr: 'Betr',
    dabble: 'Dabble',
    tabtouch: 'TabTouch',
    bluebet: 'BlueBet',
    amused: 'Amused',
};

// Canonical display order for bookmaker lists (logos, table columns,
// dropdowns). Books not listed here rank after these, alphabetically.
export const BOOKMAKER_ORDER = [
    'sportsbet',
    'tab',
    'pointsbet',
    'bet365',
    'neds',
    'ladbrokes',
    'amused',
    'betright',
    'betmakers',
    'tabtouch',
];

export function bookmakerRank(bookmaker) {
    const i = BOOKMAKER_ORDER.indexOf(bookmaker);
    return i === -1 ? BOOKMAKER_ORDER.length : i;
}

export function BookmakerLogo({ bookmaker, size = 20, className = '' }) {
    const logo = BOOKMAKER_LOGOS[bookmaker];
    const displayName = BOOKMAKER_DISPLAY_NAMES[bookmaker] || bookmaker;

    if (logo) {
        return (
            <img
                src={logo}
                alt={displayName}
                style={{ width: size, height: size }}
                className={`rounded-sm object-cover flex-shrink-0 ${className}`}
                title={displayName}
            />
        );
    }
    return (
        <span
            className={`text-[9px] font-mono text-slate-500 uppercase tracking-wider ${className}`}
            title={displayName}
            style={{ minWidth: size, minHeight: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
        >
            {(displayName || '').substring(0, 3)}
        </span>
    );
}
